import { Button, Popconfirm, Space } from 'antd'
import { useFormEditor } from '../../contexts/FormContext'

interface Props {
  onPrevTapped: () => void
  onNextTapped: (validated: boolean) => void
  onDoneTapped: (validated: boolean) => void
}
const StepperNavigation = ({
  onPrevTapped,
  onNextTapped,
  onDoneTapped,
}: Props) => {
  const {
    form: formData,
    isEmployee,
    campaignEmployee,
    steps,
    formInstance,
    activeTab,
    setActiveTab,
  } = useFormEditor()

  if (
    formData === undefined ||
    campaignEmployee === undefined ||
    formInstance == undefined
  )
    return <></>

  const next = () => {
    if (activeTab < steps.length - 1) {
      setActiveTab(activeTab + 1)
    }
  }

  const prevTapped = () => {
    onPrevTapped()
    window.scrollTo(0, 0)
    if (activeTab > 0) {
      setActiveTab(activeTab - 1)
    }
  }
  const nextTapped = () => {
    formInstance
      .validateFields({ recursive: true })
      .then((data) => {
        onNextTapped(true)
        next()
      })
      .catch((error) => {
        console.error(error)
        onNextTapped(false)
      })
  }
  const doneTapped = () => {
    formInstance
      .validateFields({ recursive: true })
      .then((data) => {
        onDoneTapped(true)
      })
      .catch((error) => {
        console.error(error)
        onDoneTapped(false)
      })
  }

  const submitDisabled = () => {
    if (isEmployee) {
      return campaignEmployee.employeeFulfilledAt != undefined
    }

    return (
      !campaignEmployee.employeeFulfilledAt ||
      campaignEmployee.managerFulfilledAt != undefined
    )
  }

  return (
    <Space
      style={{
        justifyContent: activeTab == 0 ? 'right' : 'space-between',
        width: '100%',
        padding: '10px 20px',
      }}
    >
      {activeTab > 0 && <Button onClick={prevTapped}>Précédent</Button>}
      {activeTab < steps.length - 1 && (
        <Button type="primary" onClick={nextTapped}>
          Suivant
        </Button>
      )}
      {activeTab === steps.length - 1 && (
        <Space>
          <Popconfirm
            title="Finaliser le formulaire ?"
            description="Vous ne pourrez plus modifier vos réponses"
            onConfirm={doneTapped}
            okText="Envoyer"
            cancelText="Annuler"
          >
            <Button disabled={submitDisabled()} type="primary">
              Finaliser
            </Button>
          </Popconfirm>
        </Space>
      )}
    </Space>
  )
}

export default StepperNavigation
